import "./App.scss";
import { MichelsonMap, OpKind } from "@taquito/taquito";
import {DappCore, SyncButton} from "./components/DappCore";
import { token_data } from "./data";
import React, { useState, useEffect } from "react";

const manager = new DappCore();

// helpers 
// ==========================================================================
const add_operator = async (core,fa2,owner,token_id,operator): Promise<any> => {
	const c = await core.Tezos.wallet.at(fa2);
	return {
		kind: OpKind.TRANSACTION,
		...c.methods.update_operators([{ add_operator: { operator: operator, token_id: token_id, owner: owner } }])
			.toTransferParams({ amount: 0, mutez: true, storageLimit: 100 })
	}
};

const remove_operator = async (core,fa2,owner,token_id,operator): Promise<any> => {
	const c = await core.Tezos.wallet.at(fa2);
	return {
		kind: OpKind.TRANSACTION,
		...c.methods.update_operators([{ remove_operator: { operator: operator, token_id: token_id, owner: owner } }])
			.toTransferParams({ amount: 0, mutez: true, storageLimit: 100 })
	}
};

interface ArgSpecProps {
	value: any;
	setValue: any;
	types: any;
}

export const ArgSpec = ({ value, setValue, types }: ArgSpecProps) => {

	const handleChange = (e: React.FormEvent<HTMLInputElement>, i: number): void => {
		setValue( value.map((v,j) => i == j ? e.currentTarget.value : value[j]) );
  	};

	return (
		<div>
			{types.map((x,i) => {
				return <div key={i} className="row">
					<label style={{display:"block", width:"200px"}} htmlFor="form">{x[1]}</label>
					<input style={{width:"200px"}} id="form" type={x[0]} onChange={e => handleChange(e,i)} value={value[i]}></input>			
				</div>
			})}
		</div>
	);

};

export const CallInner = (
	{ core, opFunc, afterCallback, contract, entrypoint, params } : 
	{
		core:any,
		opFunc?:any,
		afterCallback?:any,
		contract?:string,
		entrypoint?:string,
		params:any
	}) => {

	// make entrypoint pretty string

	const [inProgress, setInProgress] = useState<boolean>(false);
	if ((opFunc === undefined) && (entrypoint !== undefined)) {
		opFunc = async (core,param): Promise<any[]> => {
			const c = await core.Tezos.wallet.at(contract);
			let ops :any[] = [];
			ops.push({
				kind: OpKind.TRANSACTION,
				...c.methods[entrypoint](...param)
					.toTransferParams({ amount: 0, mutez: true, storageLimit: 500 })
			});
			return ops;
		};
	}
	const callContract = async (): Promise<void> => {
		setInProgress(true);
		try {
			if (core.beaconConnection) {
				let ops: any[] = await opFunc(core, params);
				let batch = await core.Tezos.wallet.batch(ops);
				const op = await batch.send();
				await op.confirmation();
				if (afterCallback !== undefined) {
					afterCallback();
				}
			}
		} catch (error) {
			console.log(error);
		} finally {
			setInProgress(false);
		}
	};
	return (
		<div>
			<button className="buttonCall" disabled={ inProgress } onClick={ callContract }>
				{ inProgress ? (
					<span>
					Please wait
					</span>
				) : (
					<span>
					{entrypoint}
					</span>
				)}
			</button>
	  	</div>
	);

};


export const BasicCallInterface = ({ core, opFunc, afterCallback, types, contract, entrypoint } : 
	{
		core:any,
		opFunc?:any,
		afterCallback?:any,
		types:any,
		contract?:string,
		entrypoint?:string
	}) => {

	const [value, setValue] = useState<any[]>(types.map(x => x.length==3 ? x[2]: ""));
	
	return (
		<div className="callPanel">
			<ArgSpec
				value={value}
				setValue={setValue}
				types={types}
			/>
			<CallInner
				core={core}
				opFunc={opFunc}
				afterCallback={afterCallback}
				contract={contract}
				entrypoint={entrypoint}
				params={value}
			/>
		</div>
	);
};

const CONTRACT = "KT1VuqyJmkcSk2m5L9gEgAs69t6CCDDxLtiz";
const TOKEN_FA2 = "KT1L5iQpdDZXpTvFEf6gxce3PGgiPyj8mBhy";

const collectWithToken = async (core,param): Promise<any[]> => {
	const c = await core.Tezos.wallet.at(CONTRACT);
	let ops :any[] = [];
	ops.push(await add_operator(core, TOKEN_FA2, core.userAddress, 2, CONTRACT));
	ops.push({
		kind: OpKind.TRANSACTION,
		...c.methods.collect(1, true)
			.toTransferParams({ amount: 0, mutez: true, storageLimit: 500 })
	});
	ops.push(await remove_operator(core, TOKEN_FA2, core.userAddress, 2, CONTRACT));
	return ops;
};

const collectWithTez = async (core,param): Promise<any[]> => {
	const c = await core.Tezos.wallet.at(CONTRACT);
	let ops :any[] = [];

	ops.push({
		kind: OpKind.TRANSACTION,
		...c.methods.collect(1, false)
			.toTransferParams({ amount: 10000000, mutez: true, storageLimit: 500 })
	});
	return ops;
};

const App = () => {

	const [synced, setSynced] = useState<boolean>(false);

	return (
		<div>

			<SyncButton
				core={manager}
				synced={synced}
				setSynced={setSynced}
			/>
            
			<BasicCallInterface
				core={manager}
				opFunc={collectWithToken}
				types={[]}
				entrypoint={"Mint with Knight Token!"}
			/>

			<BasicCallInterface
				core={manager}
				opFunc={collectWithTez}
				types={[]}
				entrypoint={"Mint with Tez!"}
			/>

		</div>
	)

};

export default App;
